import { gql, useMutation } from '@apollo/client';
// Query GraphQL para buscar clientes

// Query específica para busca de clientes (mais eficiente que a listagem paginada)
export const SEARCH_CUSTOMERS = gql`
  query SearchCustomers($query: String!, $withWhatsapp: Boolean) {
    searchCustomers(query: $query, withWhatsapp: $withWhatsapp) {
      id
      name
      nickname
      document
      whatsapp
      whatsappVerified
      phone
      active
      lastSale
      birthDate
      favoriteProduct
      mainContact
      tagIds
    }
  }
`;

export const UPDATE_CUSTOMER_BOT_STATUS = gql`
  mutation UpdateCustomerBotStatus($id: ID!, $botStatus: String!, $disableDuration: String) {
    updateCustomerBotStatus(input: { id: $id, botStatus: $botStatus, disableDuration: $disableDuration }) {
      customer {
        id
        botStatus
        botDisabledUntil
        timeUntilReactivation
      }
      errors
    }
  }
`;

export const useUpdateCustomerBotStatus = () => {
  return useMutation(UPDATE_CUSTOMER_BOT_STATUS);
};

export const GET_CUSTOMER_BY_ID = gql`
  query GetCustomerById($id: ID!) {
    customer(id: $id) {
      id
      name
      nickname
      createdAt
      document
      stateRegistration
      phone
      whatsapp
      whatsappVerified
      minimumOrder
      credit
      reference
      observation
      phoneExtra
      botStatus
      botDisabledUntil
      timeUntilReactivation
      aiBotDetected
      aiBotDetectedAt
      aiBotDetectionReason
      active
      lastSale
      birthDate
      favoriteProduct
      mainContact
      priceSegmentationIds
      tagIds
      tags {
        id
        name
        fontColor
        backgroundColor
        active
      }
      addresses {
        id
        number
        street
        description
        room
        zipcode
        district
        complement
        latitude
        main
        longitude
        cityId
        active
        city{
          id
          name
          state{
            id
            name
            initials
          }
        }
      }
      emails {
        id
        email
        description
        active
      }
    }
  }
`;

export const GET_CUSTOMERS = gql`
  query GetCustomers($page: Int, $perPage: Int, $search: String, $withWhatsapp: Boolean, $dateFilters: [JSON!], $advancedFilters: [JSON!], $activeOnly: Boolean) {
    customers(page: $page, perPage: $perPage, search: $search, withWhatsapp: $withWhatsapp, dateFilters: $dateFilters, advancedFilters: $advancedFilters, activeOnly: $activeOnly) {
      edges {
        node {
          id
          name
          nickname
          createdAt
          document
          stateRegistration
          phone
          whatsapp
          whatsappVerified
          minimumOrder
          credit
          reference
          observation
          phoneExtra
          active
          botStatus
          botDisabledUntil
          timeUntilReactivation
          aiBotDetected
          aiBotDetectedAt
          aiBotDetectionReason
          lastSale
          birthDate
          favoriteProduct
          mainContact
          tagIds
          tags {
            id
            name
            fontColor
            backgroundColor
            active
          }
          addresses {
            id
            fullAddress
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      },
      totalCount

    }
  }
`;

const UPDATE_CUSTOMER_STATUS = gql`
  mutation UpdateCustomerStatus($id: ID!, $active: Boolean!) {
    updateCustomerStatus(input: { id: $id, active: $active }) {
      customer {
        id
        active
      }
      errors
    }
  }
`;

export const CREATE_CUSTOMER = gql`
  mutation CreateCustomer($attributes: CustomerAttributes!) {
    createCustomer(input: { attributes: $attributes }) {
      customer {
        id
          name
          nickname
          createdAt
          document
          stateRegistration
          phone
          whatsapp
          whatsappVerified
          minimumOrder
          credit
          reference
          observation
          phoneExtra
          active
          botStatus
          botDisabledUntil
          timeUntilReactivation
          lastSale
          birthDate
          favoriteProduct
          mainContact
          priceSegmentationIds
          tagIds
          tags {
            id
            name
            fontColor
            backgroundColor
            active
          }
          addresses {
            main
            id
            fullAddress
          }
        }
      errors
    }
  }
`;

export const useUpdateCustomerStatus = () => {
  return useMutation(UPDATE_CUSTOMER_STATUS);
};

export const UPDATE_CUSTOMER = gql`
  mutation UpdateCustomer($id: ID!, $attributes: CustomerAttributes!) {
    updateCustomer(input: { id: $id, attributes: $attributes }) {
      customer {
        id
        name
        nickname
        createdAt
        document
        stateRegistration
        phone
        whatsapp
        whatsappVerified
        minimumOrder
        credit
        reference
        observation
        botStatus
        botDisabledUntil
        timeUntilReactivation
        phoneExtra
        active
        lastSale
        birthDate
        favoriteProduct
        mainContact
        priceSegmentationIds
        tagIds
        tags {
          id
          name
          fontColor
          backgroundColor
          active
        }
        addresses {
          main
          id
          fullAddress
        }
      }
      errors
    }
  }
`;

export const useUpdateCustomer = () => {
  return useMutation(UPDATE_CUSTOMER);
};

export const useCreateCustomer = () => {
  return useMutation(CREATE_CUSTOMER);
};

export const GET_ACTIVE_PRICE_SEGMENTATIONS = gql`
  query GetActivePriceSegmentations {
    activePriceSegmentations {
      id
      name
      active
    }
  }
`;

// Usar a query existente para buscar todas as tabelas de preço
export const GET_ALL_PRICE_SEGMENTATIONS = gql`
  query GetAllPriceSegmentations {
    priceSegmentations(perPage: 1000) {
      edges {
        node {
          id
          name
          active
        }
      }
    }
  }
`;

export const GET_ACTIVE_TAGS = gql`
  query GetActiveTags {
    activeTags {
      id
      name
      active
      fontColor
      backgroundColor
    }
  }
`;

export const VERIFY_CUSTOMER_WHATSAPP = gql`
  mutation VerifyCustomerWhatsapp($whatsappNumber: String!, $customerId: ID) {
    verifyCustomerWhatsapp(input: { whatsappNumber: $whatsappNumber, customerId: $customerId }) {
      success
      whatsappVerified
      message
    }
  }
`;

export const useVerifyCustomerWhatsapp = () => {
  return useMutation(VERIFY_CUSTOMER_WHATSAPP);
};

export const BULK_UPDATE_CUSTOMERS = gql`
  mutation BulkUpdateCustomers(
    $customerIds: [ID!]!
    $tagsAction: TagUpdateActionEnum
    $tagIds: [ID!]
    $activeAction: StatusUpdateActionEnum
    $active: Boolean
    $priceSegmentationAction: PriceSegmentationUpdateActionEnum
    $priceSegmentationIds: [ID!]
    $favoriteProductAction: FavoriteProductUpdateActionEnum
    $favoriteProduct: String
  ) {
    bulkUpdateCustomers(
      input: {
      customerIds: $customerIds
      tagsAction: $tagsAction
      tagIds: $tagIds
      activeAction: $activeAction
      active: $active
      priceSegmentationAction: $priceSegmentationAction
      priceSegmentationIds: $priceSegmentationIds
      favoriteProductAction: $favoriteProductAction
      favoriteProduct: $favoriteProduct}
    ) {
      success
      updatedCount
      errors
      failedCustomers {
        customerId
        error
      }
    }
  }
`

export const useBulkUpdateCustomers = () => {
  return useMutation(BULK_UPDATE_CUSTOMERS);
};

export const UNMARK_AS_AI_BOT = gql`
  mutation UnmarkAsAiBot($id: ID!) {
    unmarkAsAiBot(input: { id: $id }) {
      customer {
        id
        aiBotDetected
        aiBotDetectedAt
        aiBotDetectionReason
        repeatedMessageCount
        lastMessageHash
      }
      errors
    }
  }
`;

export const useUnmarkAsAiBot = () => {
  return useMutation(UNMARK_AS_AI_BOT);
};